<nav class="bc"
     [class.bc--rtl]="isRTL"
     aria-label="breadcrumb">
  <ol class="bc__list">
    <ng-container *ngFor="let item of breadcrumbs; let last = last; let i = index">
      <li class="bc__item" [class.bc__item--current]="last">
        <ng-container *ngIf="!last && item.url; else current">
          <a [routerLink]="item.url" class="bc__link">{{ item.label | translate }}</a>
        </ng-container>
        <ng-template #current>
          <span class="bc__current">{{ item.label | translate }}</span>
        </ng-template>
      </li>
      <li *ngIf="!last" class="bc__sep" aria-hidden="true">
        <i [ngClass]="isRTL ? 'fa-solid fa-angle-left' : 'fa-solid fa-angle-right'"></i>
      </li>
    </ng-container>
  </ol>
</nav>
